export default {
  okText: 'Ok',
  cancelText: 'Annuller'
};
